import { catClient, clientV2 } from '.';
import { GET_NOTIFICATION_COUNT, GET_NOTIFICATION_COUNT_FOR_REFURB } from './graphqlQueries/queries';

export const countQuery = () => {
  return catClient.query({ 
    query: GET_NOTIFICATION_COUNT,
    fetchPolicy: 'no-cache',
    variables: { filters: [{key: 'only_unread', value: 'true'}] }
  })
};

export const countQueryForRefurb = () => {
  return clientV2.query({ 
    query: GET_NOTIFICATION_COUNT_FOR_REFURB,
    fetchPolicy: 'no-cache',
    // variables: { filters: [{key: 'only_unread', value: 'true'}] }
  })
};
